import { Box, Button, Container, Paper } from '@mui/material';
import { Subheader } from 'components';
import TrainerDetails from 'features/trainers/TrainerDetails';
import { useAlerts, useTrainers } from 'hooks';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const TrainerShow = ({ ...props }) => {
	const navigate = useNavigate();
	const { id } = useParams();

	const { trainerId, isLoading, isLoaded, trainer, findTrainer } = useTrainers({
		id: id
	});

	const { showAlertSuccess, showAlertError } = useAlerts();

	const handleEditClick = () => navigate(`/trainers/${id}/edit`);

	useEffect(() => {
		if (id) findTrainer(id);
	}, []);

	return (
		<>
			<Subheader
				title={isLoading ? 'Loading...' : trainer.name}
				buttons={[
					<Button onClick={handleEditClick} color="primary" variant="contained">
						Edit
					</Button>
				]}
			/>
			<Container>
				<Paper>
					<Box p={4}>
						<TrainerDetails trainer={trainer} />
					</Box>
				</Paper>
			</Container>
		</>
	);
};

export default TrainerShow;
